import { StyleSheet } from 'aphrodite';

import { CustomFields } from '../CustomFields';

export class CustomFieldsPartner extends CustomFields {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/CustomFieldsPartner.js